<template>
  <div class="scroll-transform-container">
    <div class="scroll-transform-content">
      <div class="marquee-container" ref="scrollEl">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScrollTransform",
  components: {  },
  data() {
    return {
      isStop: null,
      isError: null,
      scrollEl: null
    };
  },
  props: {
    speed: {
      type: Number,
      default: 1
    },
    direction: {
      type: String,
      default: "left"
    },
    isHover: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.scrollEl = this.$refs.scrollEl;
    if (this.calc() <= 0) return;
    // this.scrollEl.addEventListener("mouseover", this.stopScroll);
    // this.scrollEl.addEventListener("mouseleave", this.startScroll);
    this.appendEl();
    this.handleStart();
  },
  beforeDestroy() {
    // this.scrollEl.removeEventListener("mouseover", this.stopScroll);
    // this.scrollEl.removeEventListener("mouseleave", this.startScroll);
    this.stopScroll();
  },
  methods: {
    appendEl() {
      try {
        const childrenNode = Array.from(this.scrollEl.children);
        childrenNode.forEach((el) => {
          const cloneChild = el.cloneNode(true);
          this.scrollEl.appendChild(cloneChild);
        });
      } catch {
        this.scrollEl.style.overflow = "auto";
        this.isError = true;
        console.log("scroll is failed");
      }
    },
    calc() {
      const { scrollLeft, offsetWidth } = this.scrollEl;
      return offsetWidth - scrollLeft;
    },
    handleStart() {
      if (this.isError || this.isStop || !this.scrollEl) return;
      const { scrollLeft, scrollWidth, offsetWidth } = this.scrollEl; 
      if (this.direction == "left") {
        if (scrollLeft + offsetWidth >= scrollWidth) {
          this.scrollEl.scrollLeft = scrollWidth / 2;
        } else {
          this.scrollEl.scrollLeft += this.speed;
        }
      } else if (this.direction == "right") {
        if (scrollLeft === 0) {
          this.scrollEl.scrollLeft = scrollWidth / 2;
        } else {
          this.scrollEl.scrollLeft -= this.speed;
        }
      }
      requestAnimationFrame(this.handleStart);
    },
    stopScroll() {
      if (this.isHover)
        this.isStop = true;
    },
    startScroll() {
      this.isStop = false;
      this.handleStart();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
